import { createSlice } from "@reduxjs/toolkit";

const screeningSlice = createSlice({
  name: "screening",
  initialState: {
    status: "idle",
    error: null,
    loading: false,
    screeningLoading: false,
    screeningError: null,
    // Screening sessions and status
    screeningSessions: [],
    currentSession: null,
    sessionStatus: null,
    // Screening questions
    screeningQuestions: [],
    // Screening results
    screeningResults: [],
    // Candidate screening sessions
    candidateScreeningSessions: {},
    // JD screening sessions
    jdScreeningSessions: {},
    // Screening analytics
    screeningAnalytics: null,
    // Active screening sessions
    activeSessions: [],
    // Screening history
    screeningHistory: [],
    // Screening state for new flow
    screeningState: null
  },
  reducers: {
    setError: (state, action) => {
      state.error = action.payload;
      state.status = "failed";
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setScreeningLoading: (state, action) => {
      state.screeningLoading = action.payload;
    },
    setScreeningError: (state, action) => {
      state.screeningError = action.payload;
    },
    // Screening sessions
    setScreeningSessions: (state, action) => {
      state.screeningSessions = action.payload;
    },
    setCurrentSession: (state, action) => {
      state.currentSession = action.payload;
    },
    setSessionStatus: (state, action) => {
      state.sessionStatus = action.payload;
    },
    // Screening questions
    setScreeningQuestions: (state, action) => {
      state.screeningQuestions = action.payload;
    },
    // Screening results
    setScreeningResults: (state, action) => {
      state.screeningResults = action.payload;
    },
    // Candidate screening sessions
    setCandidateScreeningSessions: (state, action) => {
      state.candidateScreeningSessions = action.payload;
    },
    // JD screening sessions
    setJDScreeningSessions: (state, action) => {
      state.jdScreeningSessions = action.payload;
    },
    // Screening analytics
    setScreeningAnalytics: (state, action) => {
      state.screeningAnalytics = action.payload;
    },
    // Active screening sessions
    setActiveSessions: (state, action) => {
      state.activeSessions = action.payload;
    },
    // Screening history
    setScreeningHistory: (state, action) => {
      state.screeningHistory = action.payload;
    },
    // Add session to history
    addToScreeningHistory: (state, action) => {
      state.screeningHistory.unshift(action.payload);
    },
    // Update session status
    updateSessionStatus: (state, action) => {
      const { sessionId, status } = action.payload;
      state.screeningSessions = state.screeningSessions.map(session =>
        session.session_id === sessionId ? { ...session, status } : session
      );
    },
    // Set screening state for the new flow
    setScreeningState: (state, action) => {
      state.screeningState = action.payload;
    },
    // Clear screening state
    clearScreeningState: (state) => {
      state.status = "idle";
      state.error = null;
      state.loading = false;
      state.screeningLoading = false;
      state.screeningError = null;
      state.screeningSessions = [];
      state.currentSession = null;
      state.sessionStatus = null;
      state.screeningQuestions = [];
      state.screeningResults = [];
      state.candidateScreeningSessions = {};
      state.jdScreeningSessions = {};
      state.screeningAnalytics = null;
      state.activeSessions = [];
      state.screeningHistory = [];
    }
  },
});

export const {
  setError,
  setLoading,
  setScreeningLoading,
  setScreeningError,
  setScreeningSessions,
  setCurrentSession,
  setSessionStatus,
  setScreeningQuestions,
  setScreeningResults,
  setCandidateScreeningSessions,
  setJDScreeningSessions,
  setScreeningAnalytics,
  setActiveSessions,
  setScreeningHistory,
  addToScreeningHistory,
  updateSessionStatus,
  setScreeningState,
  clearScreeningState
} = screeningSlice.actions;

// Selectors
export const selectScreeningLoading = (state) => state.screening.screeningLoading;
export const selectScreeningError = (state) => state.screening.screeningError;
export const selectScreeningSessions = (state) => state.screening.screeningSessions;
export const selectCurrentSession = (state) => state.screening.currentSession;
export const selectSessionStatus = (state) => state.screening.sessionStatus;
export const selectScreeningQuestions = (state) => state.screening.screeningQuestions;
export const selectScreeningResults = (state) => state.screening.screeningResults;
export const selectCandidateScreeningSessions = (state) => state.screening.candidateScreeningSessions;
export const selectJDScreeningSessions = (state) => state.screening.jdScreeningSessions;
export const selectScreeningAnalytics = (state) => state.screening.screeningAnalytics;
export const selectActiveSessions = (state) => state.screening.activeSessions;
export const selectScreeningHistory = (state) => state.screening.screeningHistory;
export const selectScreeningState = (state) => state.screening.screeningState;

export default screeningSlice.reducer;

